export default __webpack_public_path__ + "static/media/kite.27e24fd1.svg";